"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
//******************************************************************************
// Copyright 2018-2020, ShareSquared Inc., All Rights Reserved.
//
// Author:  Ted Iverson
// Created: 06/24/2020
//
// The contents of this file are proprietary and considered trade secret.
// Any disclosure outside of its intended use is expressly prohibited.
//******************************************************************************
var React = require("react");
var Dropdown_1 = require("@fluentui/react/lib/Dropdown");
var react_bootstrap_1 = require("react-bootstrap");
var TemplateSelector = /** @class */ (function (_super) {
    __extends(TemplateSelector, _super);
    function TemplateSelector(props, state) {
        var _this = _super.call(this, props, state) || this;
        _this.state = {
            Templates: [], TemplateName: _this.props.InitialTemplateName
        };
        return _this;
    }
    // After the component is rendered, request the list of template
    // and since the dropdown is bound to the state variable, it will
    // be updated on load
    TemplateSelector.prototype.componentDidMount = function () {
        var _this = this;
        // request the list of templates
        // NOTE: since the dropdown is bound to the state variable, it will
        // be updated when this promise if fulfilled
        // NOTE: we also have to manually call the onTemplateChanged event since
        // it isn't called automatically when the control is initialized with a value
        fetch((window.location.pathname === "/" ? "" : window.location.pathname) + "/api/templates")
            .then(function (data) { return data.json(); })
            .then(function (templates) { return _this.setState({ Templates: templates }, function () {
            var name = (_this.props.InitialTemplateName.length !== 0 ? _this.props.InitialTemplateName : _this.state.Templates[0].name);
            _this.setState({ Templates: templates, TemplateName: name });
            _this.handleOnChange(name);
        }); })
            .catch(function (e) {
            console.log(e);
            _this.setState({ Templates: [] });
            if (_this.props.OnError)
                _this.props.OnError("An error occurred processing the configuration. Contact the site administrator.");
        });
    };
    TemplateSelector.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "S2TemplateSelector", hidden: this.props.InitialTemplateName.length !== 0 || this.state.Templates === null || this.state.Templates.length < 2 },
            React.createElement(react_bootstrap_1.Container, null,
                React.createElement(react_bootstrap_1.Row, null,
                    React.createElement(react_bootstrap_1.Col, { lg: "4" },
                        React.createElement(Dropdown_1.Dropdown, { label: "Search for", className: "S2Input S2DropdownField", options: this.state.Templates.map(function (t) {
                                return { key: t.name, text: t.name };
                            }), selectedKey: this.state.TemplateName, onChange: function (evt, val) {
                                _this.setState({ TemplateName: val === null || val === void 0 ? void 0 : val.key });
                                _this.handleOnChange(val === null || val === void 0 ? void 0 : val.key);
                            } }))))));
    };
    TemplateSelector.prototype.handleOnChange = function (key) {
        if (this.props.OnTemplateChanged) {
            var template = this.state.Templates.find(function (t) { return t.name === key; });
            this.props.OnTemplateChanged(template);
        }
    };
    return TemplateSelector;
}(React.Component));
exports.default = TemplateSelector;
//# sourceMappingURL=TemplateSelector.js.map